<template>
  <div class="col-12">
    <div class="row d-flex justify-content-center align-items-center">
      <div class="col-10 col-lg-6">
        <div class=" row text-center ml-5">
          <div class="mb-5">
            <img src="../../assets/tn_cybertech_grad_logo.png" class="tn-logo" style="width: 200px; height: auto;">
          </div>
          <h2 class="ui inverted purple text">HEPII day, <strong>Welcome!</strong></h2>
          <p v-if="!otpSent" class="text-muted mt-4">Lets verify your phone number{{ hasEmail ? ' and email' : '' }}.</p>
          <p v-else class="text-muted mt-4">
            OTP has been sent to <strong>{{ auth.phone }}</strong>{{ hasEmail ? ' and <strong>' + auth.email + '</strong>' : '' }}.
          </p>
        </div>
        <form v-bind:class="{ 'ui form double loading': isBusy() }" @submit.prevent="submitForm()">

          <div class="ui large form mt-5">
            <div class="field floating">
              <label class="text-muted">Phone</label>
              <input class="primary" type="text" disabled v-model="auth.phone" placeholder="">
            </div>
            <div v-if="hasEmail" class="field floating">
              <label class="text-muted">Email</label>
              <input class="primary" type="text" disabled v-model="auth.email" placeholder="">
              <small v-if="!otpSent" class="text-muted mt-1">OTP will be sent to both phone and email</small>
            </div>
            <div v-if="otpSent" class="field">
              <label>Enter OTP</label>
              <input type="text" v-model="auth.otp" placeholder="Enter the OTP you received" maxlength="6">
              <small class="text-muted mt-1">Check your phone{{ hasEmail ? ' or email' : '' }} for the OTP</small>
            </div>
            <div class="ui center right aligned two column grid">
              <div class="column"></div>
              <div class="column">
                <!-- <a href="http://localhost:8080/lab/auth" class="ui purple tertiary button">Forgot Password</a> -->
              </div>
            </div>
            <button v-if="!otpSent" class="ui button large purple fluid mt-4" :disabled="!isFormValid"
              type="submit">
              Send OTP
              <i class="arrow right icon"></i>
            </button>
            <button v-if="otpSent" class="ui button large purple fluid mt-4" :disabled="!isOtpValid"
              type="submit">
              Verify OTP
              <i class="check icon"></i>
            </button>
            <button v-if="otpSent" type="button" class="ui button large basic purple fluid mt-4" @click="resendOtp()">
              Resend OTP
            </button>
            <button type="button" class="ui button large basic grey fluid mt-4" @click="back()">
              Back
            </button>

            <!-- <div class="d-flex align-items-end mt-4">
                <p class="fw-lighter">Don't have a profile yet?
                  <a @click="register()" class="ui purple tertiary button align-self-end">Register Here!</a>
                </p>
              </div> -->
            <!-- <div class="ui fitted divider mt-2"></div> -->
            <!-- <div class="d-flex align-items-end mt-3">
                  <p class="fw-light"> A step-by-step guide on how to open an account as a
                    <a @click="openPdf('NewCustomer.pdf')" class="ui purple tertiary button align-self-end">New Customer</a>
                    or
                    <a @click="openPdf('ExistingCustomer.pdf')" class="ui purple tertiary button align-self-end">Existing Customer</a>
                  </p>
                </div> -->
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
import baseMethods from "@/utils/baseMethods";
import { Notify } from "@/utils/notifications";
import { useAuthStore } from '@/stores/auth';

export default {
  name: "VerifyPhone",
  setup() {
    const authStore = useAuthStore();
    return { authStore };
  },
  data() {
    return {
      otpSent: false,
      auth: {
        channel: "MOBILE",
        phone: "",
        email: "",
        expiry: 5,
        purpose: 'REGISTER',
        otp: "",
        uuid: ""
      },
      errors: {},
      operations: 0,
    };
  },
  computed: {
    storedPhone() { return this.authStore.phone; },
    storedEmail() { return this.authStore.email; },
    isPhoneParamProvided() { return this.authStore.isPhoneParamProvided; },
    hasEmail() {
      return !!this.auth.email;
    },
    isFormValid() {
      return !!this.auth.phone;
    },
    isOtpValid() {
      return !!this.auth.otp && this.auth.otp.length >= 4;
    },
  },
  mounted() {
    this.initializeFromStore();
  },
  methods: {
    initializeFromStore() {
      this.auth.phone = this.storedPhone;
      this.auth.email = this.storedEmail || "";
    },

    submitForm() {
      if (this.otpSent) {
        this.verifyOtp();
      } else {
        this.sendOtp();
      }
    },

    sendOtp() {
      const payload = {
        channel: this.auth.channel,
        phone: this.auth.phone,
        email: this.auth.email || undefined,
        expiry: this.auth.expiry,
        purpose: this.auth.purpose,
        username: this.auth.phone,
        requestType: 'SEND_OTP',
      };

      this.post_auth_no_auth('/authentication', payload, "OTP Sent").then((res) => {
        if (res && res.success) {
          this.otpSent = true;
          if (res.body && res.body.uuid) {
            this.auth.uuid = res.body.uuid;
            this.setUuid(res.body.uuid);
          }
        }
      });
    },

    verifyOtp() {
      const payload = {
        phone: this.auth.phone,
        otp: this.auth.otp,
        uuid: this.auth.uuid,
        username: this.auth.phone,
        requestType: 'VERIFY_OTP',
      };

      this.post_auth_no_auth('/authentication', payload, "OTP Verified").then((res) => {
        if (res && res.success) {
          this.$router.push('/omni/home');
        } else if (res) {
          Notify.fire("Error", res.message || "OTP verification failed. Please try again.", "error");
        } else {
          Notify.fire("Error", "OTP verification failed. Please try again.", "error");
        }
      });
    },

    resendOtp() {
      this.auth.otp = "";
      this.sendOtp();
    },
    setUuid(uuid) { this.authStore.uuid = uuid; },
    back() {
      this.$router.push('/omni');
    },
    ...baseMethods,
  },
};
</script>